module.exports = __webpack_public_path__ + "static/media/Github_IMG.26c9cf1f.png";